<div [ngClass]="size"></div>
